<template>
  <div>
    <v-dialog v-model="show_dialog_box" max-width="800px">
      <template v-slot:activator="{ on }">
        <v-icon v-on="on" color="dark" @click="onShowDialog">mdi-square-edit-outline</v-icon>
      </template>
      <v-card class="pa-5" color="pop_bg">
        <div class=" tw-flex tw-w-full tw-justify-between tw-items-center">
          <v-card-title class="dark--text text-h6 mt-n2 ms-2">Edit Category</v-card-title>
          <v-btn color="dark" text @click="close"><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <v-divider></v-divider>
        <v-card-text>
          <div class="mt-2 tw-flex tw-flex-col tw-gap-4">
            <h3 class=" dark--text text-body-1 font-weight-bold">
              Enter Meal Category Details
            </h3>
            <v-form class="" @submit="updateCategory()" v-model="valid" ref="form">
              <div class=" tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-4">
                <div class="tw-flex tw-flex-col tw-gap-1">
                  <h5 class="text-body-2 dark--text">
                    Category Name
                  </h5>
                  <div>
                    <v-text-field label="Category Name" v-model="category.nameEn" :rules="[requiredValidator('category name')]" solo dense></v-text-field>
                  </div>
                </div>
                <div class="tw-flex tw-flex-col tw-gap-1">
                  <h5 class="text-body-2 dark--text">
                    Category Name (Arabic)
                  </h5>
                  <div>
                    <v-text-field v-model="category.nameAr" label="Category Name Arabic" :rules="[requiredValidator('category name in arabic')]" solo dense></v-text-field>
                  </div>
                </div>

                <div>
                  <v-checkbox v-model="category.pcValueNotRequired" label="Hide P/C Value"> </v-checkbox>
                </div>
                <div>
                  <v-checkbox v-model="category.pcCustomization" label="Custimize P/C (Main Cource)"> </v-checkbox>
                </div>

                <div>
                  <h5 class="text-body-2 dark--text">Currently Active</h5>
                  <div>
                    <v-radio-group v-model="category.active" :mandatory="false" row>
                      <v-radio label="Yes" :value="true"></v-radio>
                      <v-radio label="No" :value="false"></v-radio>
                    </v-radio-group>
                  </div>
                </div>

                <div class=" tw-flex tw-flex-col tw-gap-1">
                  <h5 class="text-body-2 dark--text">Show Order</h5>
                  <v-text-field :rules="[requiredValidator('order')]" solo dense type="number" v-model="category.showOrder" min="0" label="Show Order" @keypress="isNumber"></v-text-field>
                </div>
                <div class=" tw-flex tw-flex-col tw-gap-1">
                  <h5 class="text-body-2 dark--text">Category Type</h5>
                  <v-select
                    :items="categoryTypes"
                    :rules="[requiredValidatorSelect('category type')]"
                    v-model="categoryType"
                    item-text="nameEn"
                    item-value="_id"
                    label="Category Type"
                    dense
                    :loading="loading"
                    solo
                  ></v-select>
                </div>

                <div class=" tw-flex tw-flex-col tw-gap-1">
                  <h5 class="text-body-2 dark--text">Select icon</h5>
                  <div class=" tw-flex tw-justify-between">
                    <v-img :src="category.icon" max-width="30" height="30"> </v-img>
                    <categoryIcons @updateIcon="updateIcon"></categoryIcons>
                  </div>
                </div>
                <div class=" tw-flex tw-flex-col tw-gap-1">
                  <h5 class="text-body-2 dark--text">Map To</h5>
                  <v-autocomplete :items="categoriesList" v-model="category.migrateTo" item-text="nameEn" item-value="_id" label="Map To Category" dense :loading="loading" solo></v-autocomplete>
                </div>
              </div>

              <div class=" tw-flex tw-w-full tw-justify-end">
                <v-btn :width="$vuetify.breakpoint.smAndUp ? 120 : 90" color="primary" class=" text-capitalize" @click="updateCategory()" :loading="btnloading" :disabled="!valid">Save</v-btn>
              </div>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" timeout="3000" right top color="success">{{ text }}</v-snackbar>
  </div>
</template>

<script>
import { requiredValidator, requiredValidatorSelect } from "../../core/methods/validations";
import categoryIcons from "../components/CategoryIcons.vue";
export default {
  components: {
    categoryIcons,
  },
  apollo: {
    getAllCategories() {
      return {
        query: require("@/menu-packages/api/getAllCategories.graphql"),
        variables: {
          limit: 0,
          skip: 0,
        },
        result({ data, loading }) {
          this.loading = loading;
          this.categoriesList = data.getAllCategories.category;
        },
      };
    },
    getAllCategoryTypes() {
      return {
        query: require("../api/getAllCategoryTypes.graphql"),
        result({ data }) {
          if (data.getAllCategoryTypes) {
            this.categoryTypes = data.getAllCategoryTypes;
          }
        },
      };
    },
  },
  props: {
    categoryInfo: {
      required: true,
    },
  },
  created() {
    this.category = JSON.parse(JSON.stringify(this.categoryInfo));
    this.categoryType = this.category.categoryType ? this.category.categoryType._id : null;
  },
  data() {
    return {
      requiredValidator: requiredValidator,
      requiredValidatorSelect,
      btnloading: false,
      valid: true,
      errors: [],
      snackbar: false,
      text: "",
      category: [],
      show_dialog_box: false,
      categoriesList: [],
      categoryTypes: [],
      categoryType: "",
    };
  },
  methods: {
    updateIcon(icon) {
      this.category.icon = icon;
    },
    onShowDialog() {
      this.category = JSON.parse(JSON.stringify(this.categoryInfo));
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    updateCategory() {
      //   console.log(this.category);
      this.categoryInfo.nameEn = this.category.nameEn;
      this.categoryInfo.nameAr = this.category.nameAr;
      this.categoryInfo.active = this.category.active;
      this.categoryInfo.showOrder = this.category.showOrder;
      this.categoryInfo.pcValueNotRequired = this.category.pcValueNotRequired;
      this.categoryInfo.icon = this.category.icon;
      this.categoryInfo.pcCustomization = this.category.pcCustomization;

      this.btnloading = true;
      this.$apollo
        .mutate({
          mutation: require("@/menu-packages/api/updateCategory.graphql"),
          variables: {
            id: this.category._id,
            nameEn: this.category.nameEn,
            nameAr: this.category.nameAr,
            showOrder: this.category.showOrder,
            active: this.category.active,
            pcValueNotRequired: this.category.pcValueNotRequired,
            migrateTo: this.category.migrateTo,
            icon: this.category.icon,
            categoryType: this.categoryType,
            pcCustomization: this.category.pcCustomization,
          },
          update: () => {
            // this.$refs.form.reset();
            this.btnloading = false;
            this.show_dialog_box = false;
          },
        })
        .catch(error => {
          if (error.graphQLErrors != null) {
            console.error(error.graphQLErrors);
          }
          this.btnloading = false;
        });
    },
    close() {
      this.show_dialog_box = false;
      // this.$refs.form.reset();
    },
  },
};
</script>

<style>
.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 0.2 !important;
}
</style>
